import React, { FC } from "react";

interface InfoCardProps {
  title: string;
  description: string | React.ReactNode;
  price_text: string | number;
  img_url: string | null;
}

const InfoCard: FC<InfoCardProps> = ({
  description,
  img_url,
  price_text,
  title,
}) => {
  return (
    <div className="flex gap-6 bg-[#FAF7F6]">
      {img_url ? (
        <div className="p-6 flex flex-row gap-6">
          <img
            className="object-cover w-[40%] h-full"
            alt="text"
            src={img_url}
            loading="lazy"
          />
          <div className="w-[60%] flex flex-col gap-2">
            <span className="text-[#99472A] font-bold text-base ">{title}</span>
            <div className="flex flex-col">{description}</div>
            <span className="flex justify-center text-[18px]  font-normal py-2">
              {price_text},-
            </span>
            {/* <div className="w-full flex items-end h-full">
              <button className="text-[18px] w-full font-semibold  bg-[#ECCDC2] rounded-[60px]">
                {globalThis.translate.em.proposal.signature_page.more_info}
              </button>
            </div> */}
          </div>
        </div>
      ) : (
        <div className="p-6 flex flex-row gap-6 w-full">
          <div className="w-full flex flex-col gap-2 p-6 justify-center items-center">
            <span className="text-[#99472A] font-bold text-base ">{title}</span>
            <div className="flex flex-col">{description}</div>
            <span className="flex justify-center text-[18px]  font-normal py-2">
              {price_text},-
            </span>
            {/* <div className="w-full flex items-end h-full">
              <button className="text-[18px] w-full font-semibold  bg-[#ECCDC2] rounded-[60px]">
                {globalThis.translate.em.proposal.signature_page.more_info}
              </button>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoCard;
